import { useUpdateEffect } from 'ahooks';
import React, { useRef } from 'react';
import { customEvents, getSpecificParent } from '@apia/util';
import { DefaultTabsLabelRenderer } from './renderers/DefaultTabsLabelRenderer';
import { observer } from 'mobx-react-lite';
import { Tab } from './tabsController';
import { Box } from '@apia/theme';

const Item = observer(({ tab }: { tab: Tab }) => {
  const Renderer = React.useMemo(
    () => tab.state.labelRenderer ?? DefaultTabsLabelRenderer,
    [tab.state.labelRenderer],
  );

  const uns = useRef(() => {});
  const ref = React.useRef<HTMLButtonElement>({} as HTMLButtonElement);
  useUpdateEffect(() => {
    if (tab.state.isFocused) {
      ref.current?.focus({
        preventScroll: true,
      });
    }
  }, [tab.state.isFocused]);
  React.useEffect(() => {
    if (tab.state.isOpen) {
      const scrollParent = getSpecificParent(ref.current, (current) =>
        current.classList.contains('tabs__list'),
      ) as HTMLElement;

      scrollParent?.scroll({
        left: ref.current.offsetLeft - 100,
      });
    }
  }, [tab.state.isOpen]);

  const boxProps = {
    className: `tabs__item__wrapper ${tab.state.isOpen ? 'open' : ''} ${
      tab.state.isDisabled ? 'disabled' : ''
    }`,
    title: tab.state.title ?? tab.state.label,
    'aria-controls': `tabpanel-${tab.controller.id}-${tab.state.id}`,
    'aria-selected': tab.state.isOpen ?? false,
    id: `tab-${tab.controller.id}-${tab.id}`,
    tabIndex: tab.state.isOpen ? 0 : -1,
    role: 'tab',
    variant: 'inherit',
  };

  return (
    <Box
      data-id={tab.id}
      ref={(el) => {
        uns.current();
        ref.current = el;
        if (
          el instanceof HTMLElement &&
          tab.controller.state.listenFocusEvents !== false
        ) {
          const handleFocus = () => {
            tab.open();
          };
          el.addEventListener(customEvents.focus, handleFocus);
          uns.current = () => {
            el.removeEventListener(customEvents.focus, handleFocus);
          };
        }
      }}
      {...boxProps}
    >
      <Renderer tab={tab} />
    </Box>
  );
});

export default Item;
